export default activity => activity && activity.from.role === 'bot';
